import { Root, StyledSpinner } from './Spinner.ui';

type SpinnerProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: number;
};

export const Spinner = (props: SpinnerProps) => {
  return (
    <Root {...props}>
      <StyledSpinner />
    </Root>
  );
};
